import React from 'react';
import { Link } from 'react-router-dom';
import AnimatedSection from '../../components/ui/AnimatedSection';

const CtaSection = () => {
  return (
    <section className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/40 to-purple-900/40"></div>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <AnimatedSection>
          <h2 className="text-4xl md:text-6xl font-extrabold text-white mb-6">
            Ready to Dominate NYC Search Results?
          </h2>
          <p className="text-xl text-slate-300 mb-10 max-w-3xl mx-auto leading-relaxed">
            Stop losing customers to competitors who rank higher. Get a comprehensive, free SEO audit and discover exactly how we will increase your local traffic, improve Google ranking, and establish your brand in AI search engines.
          </p>
          <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6">
            <Link to="/contact" className="bg-blue-600 hover:bg-blue-500 text-white px-10 py-5 rounded-full text-lg font-bold transition-all shadow-[0_0_30px_rgba(37,99,235,0.5)] w-full sm:w-auto">
              Get Your Free SEO Audit
            </Link>
            <Link to="/contact" className="bg-transparent border-2 border-white hover:bg-white hover:text-slate-950 text-white px-10 py-5 rounded-full text-lg font-bold transition-all w-full sm:w-auto">
              Schedule a Consultation
            </Link>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default CtaSection;